import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import useConfiguration from 'hooks/useConfiguration';

/** Clave backoffice: "true" muestra Mercado Pago para todos los usuarios. */
const CONFIG_VISIBLE_FOR_ALL = 'mercadopagoVisibleForAll';
/** Clave backoffice: lista de idCliente (o "all") con acceso a Mercado Pago. Igual que usersKlu. */
const CONFIG_USERS_MERCADOPAGO = 'usersMercadoPago';

/**
 * Determina si el apartado de Mercado Pago debe mostrarse.
 * Todo desde la configuración del backoffice (global_configurations):
 * - mercadopagoVisibleForAll: "true" → visible para todos.
 * - usersMercadoPago: string con idCliente separados por coma o "all" → visible para esos clientes.
 * @returns {{ visible: boolean, loading: boolean }}
 */
export function useMercadoPagoVisible() {
  const { getConfigurationValue } = useConfiguration();
  const { user } = useSelector((state) => state.session);

  const visible = useMemo(() => {
    const visibleForAll = getConfigurationValue(CONFIG_VISIBLE_FOR_ALL);
    if (['true', true].includes(visibleForAll)) {
      return true;
    }
    if (!user?.clientId) {
      return false;
    }
    const users = (getConfigurationValue(CONFIG_USERS_MERCADOPAGO) || '').split(',');
    return users.includes(user.clientId) || users.includes('all');
  }, [getConfigurationValue, user?.clientId]);

  return {
    visible,
    loading: false,
  };
}
